(() => {
  const initSlider = (root) => {
    if (root.dataset.mumanySliderReady === 'true') return;
    const slides = [...root.querySelectorAll('[data-mumany-slide]')];
    const dots = [...root.querySelectorAll('[data-mumany-dot]')];
    if (slides.length < 2) return;
    root.dataset.mumanySliderReady = 'true';
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === active);
        slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
        slide.querySelectorAll('a,button').forEach((item) => { item.tabIndex = i === active ? 0 : -1; });
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
    };
    const start = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
      clearInterval(timer);
      timer = setInterval(() => show(active + 1), 6000);
    };
    root.querySelector('[data-mumany-prev]')?.addEventListener('click', () => { show(active - 1); start(); });
    root.querySelector('[data-mumany-next]')?.addEventListener('click', () => { show(active + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', start);
    let x = 0;
    root.addEventListener('touchstart', (event) => { x = event.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - x;
      if (Math.abs(delta) > 45) { show(active + (delta < 0 ? 1 : -1)); start(); }
    }, { passive: true });
    show(0);
    start();
  };
  const init = (scope = document) => scope.querySelectorAll('[data-mumany-slider]').forEach(initSlider);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

(() => {
  const initMoments = (root) => {
    if (root.dataset.mumanyMomentsReady) return;
    const track = root.querySelector('.mumany-moments__track');
    const cards = [...(track?.querySelectorAll('.mumany-moment') || [])];
    if (cards.length < 2) return;
    root.dataset.mumanyMomentsReady = 'true';
    const previous = root.querySelector('[data-mumany-moment-previous]');
    const next = root.querySelector('[data-mumany-moment-next]');
    const status = root.querySelector('[data-mumany-moment-status]');
    let active = 0;
    let scrollFrame;
    const update = (index) => {
      active = Math.max(0, Math.min(cards.length - 1, index));
      cards.forEach((card, i) => card.classList.toggle('is-active', i === active));
      if (previous) previous.disabled = active === 0;
      if (next) next.disabled = active === cards.length - 1;
      if (status) status.textContent = `${active + 1} / ${cards.length}`;
    };
    const show = (index) => {
      const selected = Math.max(0, Math.min(cards.length - 1, index));
      update(selected);
      const desired = cards[selected].offsetLeft - cards[0].offsetLeft;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      track.scrollTo({ left: Math.min(desired, maximum), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous?.addEventListener('click', () => show(active - 1));
    next?.addEventListener('click', () => show(active + 1));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const center = track.scrollLeft + track.clientWidth / 2;
        const firstLeft = cards[0].offsetLeft;
        const closest = cards.reduce((best, card, i) =>
          Math.abs(card.offsetLeft - firstLeft + card.offsetWidth / 2 - center) <
          Math.abs(cards[best].offsetLeft - firstLeft + cards[best].offsetWidth / 2 - center) ? i : best, 0);
        update(closest);
      });
    }, { passive: true });
    root.addEventListener('shopify:block:select', (event) => {
      const index = cards.indexOf(event.target.closest('.mumany-moment'));
      if (index >= 0) show(index);
    });
    update(0);
  };
  const init = (scope = document) => {
    if (scope.matches?.('[data-mumany-moments]')) initMoments(scope);
    scope.querySelectorAll('[data-mumany-moments]').forEach(initMoments);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();


(() => {
  const initAbout = (root) => {
    if (root.dataset.mumanyAboutReady) return;
    const tabs = [...root.querySelectorAll('[data-mumany-about-tab]')];
    const panels = [...root.querySelectorAll('[data-mumany-about-panel]')];
    if (!tabs.length) return;
    root.dataset.mumanyAboutReady = 'true';
    const activate = (tab, focus = false) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(tabs[next], true);
      });
    });
    root.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-mumany-about-panel]');
      const tab = panel && tabs.find((item) => item.getAttribute('aria-controls') === panel.id);
      if (tab) activate(tab);
    });
    activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
  };
  const initContact = (root) => {
    if (root.dataset.mumanyContactReady) return;
    const toggle = root.querySelector('[data-mumany-contact-toggle]');
    const panel = root.querySelector('[data-mumany-contact-panel]');
    if (!toggle || !panel) return;
    root.dataset.mumanyContactReady = 'true';
    toggle.setAttribute('aria-expanded', String(!panel.hidden));
    toggle.addEventListener('click', () => {
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
      if (!panel.hidden) panel.querySelector('input, textarea')?.focus();
    });
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-mumany-about]').forEach(initAbout);
    scope.querySelectorAll('[data-mumany-contact]').forEach(initContact);
    if (scope.matches?.('[data-mumany-about]')) initAbout(scope);
    if (scope.matches?.('[data-mumany-contact]')) initContact(scope);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

// Position Shopify's hosted account sheet below the custom Mumany header icon.
document.addEventListener('open', (event) => {
  const account = event.target;
  if (!(account instanceof HTMLElement) || !account.matches('shopify-account.mumany-header__account')) return;
  account.style.setProperty('--account-dialog-top', `${Math.max(0, Math.round(account.getBoundingClientRect().bottom))}px`);
}, true);

(() => {
  const media = window.matchMedia('(max-width: 1350px)');
  const syncScroll = () => {
    document.documentElement.classList.toggle('mumany-drawer-open', media.matches && !!document.querySelector('[data-mumany-drawer][open]'));
  };
  const close = (root, restoreFocus = true) => {
    if (!root.open) return;
    root.open = false;
    syncScroll();
    if (restoreFocus) root.querySelector('[data-mumany-drawer-trigger]')?.focus({ preventScroll: true });
  };
  const initDrawer = (root) => {
    if (root.dataset.mumanyDrawerReady) return;
    root.dataset.mumanyDrawerReady = 'true';
    const trigger = root.querySelector('[data-mumany-drawer-trigger]');
    const panel = root.querySelector('nav');
    if (!trigger || !panel) return;
    root.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', String(root.open));
      trigger.setAttribute('aria-label', root.open ? trigger.dataset.closeLabel : trigger.dataset.openLabel);
      if (root.open) {
        document.querySelectorAll('[data-mumany-drawer][open]').forEach((other) => {
          if (other !== root) other.open = false;
        });
        panel.querySelector('[data-mumany-drawer-close]')?.focus({ preventScroll: true });
      }
      syncScroll();
    });
    root.querySelectorAll('[data-mumany-drawer-close]').forEach((button) => button.addEventListener('click', () => close(root)));
    panel.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) close(root, false);
    });
    panel.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !root.open) return;
      const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')]
        .filter((item) => item.getClientRects().length);
      if (!focusable.length) return;
      if (event.shiftKey && document.activeElement === focusable[0]) {
        event.preventDefault();
        focusable[focusable.length - 1].focus();
      } else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
        event.preventDefault();
        focusable[0].focus();
      }
    });
  };
  const init = (scope = document) => {
    if (scope.matches?.('[data-mumany-drawer]')) initDrawer(scope);
    scope.querySelectorAll('[data-mumany-drawer]').forEach(initDrawer);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-mumany-drawer][open]');
    if (open) { event.preventDefault(); close(open); }
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const drawer = event.target.querySelector('[data-mumany-drawer]');
    if (drawer) close(drawer, false);
  });
  media.addEventListener('change', () => {
    if (!media.matches) document.querySelectorAll('[data-mumany-drawer][open]').forEach((root) => close(root, false));
    syncScroll();
  });
})();

(() => {
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const selector = [
    '.mumany-products__track > *', '.mumany-stories__track > *',
    '.mumany-moments__track > *', '.mumany-choices__grid > *',
    '.mumany-benefits__grid > *', '.mumany-home__heading',
    '.mumany-about__panel-copy', '.mumany-about__panel-media',
    '.mumany-about-details__feature', '.mumany-about-details__product',
    '.mumany-faq__intro', '.mumany-faq__group', '.mumany-faq__item',
    '.mumany-contact__card h1', '.mumany-contact__description', '.mumany-collection-hero__content',
    '.mumany-collection-hero__media', '.mumany-product-heading',
    '.mumany-footer__brand', '.mumany-footer__menu'
  ].join(',');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px 40px 0px' });
  const init = (scope = document) => {
    const nodes = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) nodes.unshift(scope);
    nodes.forEach((node) => {
      if (node.classList.contains('mumany-reveal')) return;
      node.classList.add('mumany-reveal');
      observer.observe(node);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const node = event.target.closest('.mumany-reveal');
    if (node) node.classList.add('is-visible');
  });
})();

// Measure the custom header for the product page's sticky navigation and details.
(() => {
  let observer;
  const init = () => {
    observer?.disconnect();
    const header = document.querySelector('[data-sticky-product-header]');
    const group = header?.closest('#header-group');
    if (!header || !group) return;
    const announcement = group.querySelector('.mumany-announcement');
    const measure = () => {
      group.style.setProperty('--mumany-announcement-height', `${announcement?.offsetHeight || 0}px`);
      document.documentElement.style.setProperty('--mumany-sticky-header-height', `${header.offsetHeight}px`);
      document.body.style.setProperty('--sticky-header-offset', `${header.offsetHeight + 12}px`);
    };
    measure();
    observer = new ResizeObserver(measure);
    observer.observe(header);
    if (announcement) observer.observe(announcement);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

// Keep the custom cart badge in sync with Horizon's native AJAX cart events.
(() => {
  const setCount = (value) => {
    const count = Number(value);
    if (!Number.isFinite(count) || count < 0) return;
    document.querySelectorAll('[data-mumany-cart]').forEach((link) => {
      const badge = link.querySelector('.mumany-cart-count');
      if (badge) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count === 0;
      }
      link.setAttribute('aria-label', `${link.dataset.cartLabel}, ${count} ${link.dataset.cartItemsLabel}`);
    });
    try { sessionStorage.setItem('mumany-cart-count', JSON.stringify({ value: count, timestamp: Date.now() })); } catch (_) {}
  };
  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (count != null) setCount(count);
    }).catch(() => {});
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const link = document.querySelector('[data-mumany-cart]');
    if (!link) return;
    fetch(`${link.getAttribute('href').replace(/\/$/, '')}.js`, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => { if (cart?.item_count != null) setCount(cart.item_count); })
      .catch(() => {});
  });
})();
